import { Outlet } from 'react-router-dom';
import styled from 'styled-components';
import { Stack } from 'components/Stack';

import MessageNavigation from 'components/SidebarLayout/MessageNavigation';

const MessageMenu = () => {
  const wrapper_min_width = '1192px';
  return (
    <MessageWrapper direction="row" align="start" minWidth={wrapper_min_width}>
      <MessageNavigation />
      <>
        <Outlet />
      </>
    </MessageWrapper>
  );
};
export default MessageMenu;

const MessageWrapper = styled(Stack)<{ minWidth: string }>`
  ${({ theme, minWidth }) => ({
    borderTop: `1px solid ${theme.colors.RG06}`,

    display: 'flex',
    width: '100%',
    height: 'calc(100vh - 72px)',
    background: 'white',
    cursor: 'default',
  })}
`;

export const MessageLayoutWrapper = styled(Stack)`
  ${({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'start',
    width: '100%',
    height: '100%',
    // overflowX: 'hidden',
  })}
`;
